module.exports = __webpack_public_path__ + "static/media/AR.4f098aa5.svg";